export default {
  avis: [],
}
